import { Link, useLocation, useRouteError } from "react-router-dom";
import { Button } from "../components/button.jsx";
import React from "react";
import Bugsnag from "@bugsnag/js";

export function ErrorPage() {
  let error = useRouteError();
  Bugsnag.notify(error);
  let location = useLocation();
  return (
    <div className={"p-3 flex flex-col gap-3"}>
      <div>Oops... Something went wrong</div>
      <Link to={location.pathname}>
        <Button>reload_page</Button>
      </Link>
    </div>
  );
}
